export default "<qr-code [value]=\"qrcode\" size=\"300\"></qr-code>";